import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d751005"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Variant Custom Finishing Configuration", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-x" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "row mt-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Finishing Type:", -1))
const _hoisted_12 = { class: "col-8" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "row mt-1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Substrates:", -1))
const _hoisted_17 = { class: "col-8" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 1,
  class: "row mt-1"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Substrate Size:", -1))
const _hoisted_22 = { class: "col-8" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 2,
  class: "row mt-1"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Fixing:", -1))
const _hoisted_26 = { class: "col-8" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 3,
  class: "row mt-1"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Backing:", -1))
const _hoisted_31 = { class: "col-8" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 4,
  class: "row mt-1"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Colour:", -1))
const _hoisted_36 = { class: "col-8" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 5,
  class: "row mt-1"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Lamination:", -1))
const _hoisted_41 = { class: "col-8" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 6,
  class: "row mt-1"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Frame Type:", -1))
const _hoisted_46 = { class: "col-8" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 7,
  class: "row mt-1"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Moulding:", -1))
const _hoisted_51 = { class: "col-8" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " choose ", -1))
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 8,
  class: "row mt-1"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Moulding Size:", -1))
const _hoisted_56 = { class: "col-8" }
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 9,
  class: "row mt-1"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Glass:", -1))
const _hoisted_60 = { class: "col-8" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " None ", -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = {
  key: 10,
  class: "row mt-1"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Hanging Option:", -1))
const _hoisted_65 = { class: "col-8" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " None ", -1))
const _hoisted_67 = ["value"]
const _hoisted_68 = {
  key: 11,
  class: "row mt-1"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Window Mount:", -1))
const _hoisted_70 = { class: "col-8" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " None ", -1))
const _hoisted_72 = ["value"]
const _hoisted_73 = {
  key: 12,
  class: "row mt-1"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, "Borders:", -1))
const _hoisted_75 = { class: "col-8" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-6" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Top (mm):", -1))
const _hoisted_79 = { class: "col-6" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Right (mm):", -1))
const _hoisted_81 = { class: "col-6" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bottom (mm):", -1))
const _hoisted_83 = { class: "col-6" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Left (mm):", -1))
const _hoisted_85 = { class: "row mt-1" }
const _hoisted_86 = { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }
const _hoisted_87 = { class: "col-8" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-1 p-0" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "mt-3" })
], -1))
const _hoisted_89 = { class: "row mt-1" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }, " Custom Delivery Option ", -1))
const _hoisted_91 = { class: "col-8" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, " None ", -1))
const _hoisted_93 = ["value"]
const _hoisted_94 = { class: "delivery-options" }
const _hoisted_95 = { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }
const _hoisted_96 = { class: "col-8" }
const _hoisted_97 = { class: "col-4 fw-bold d-flex align-items-center justify-content-end" }
const _hoisted_98 = { class: "col-8" }
const _hoisted_99 = ["onUpdate:modelValue"]
const _hoisted_100 = {
  key: 1,
  class: "row"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { class: "modal-footer" }
const _hoisted_104 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-mask",
            onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.oBackDropClick && _ctx.oBackDropClick(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", {
                    class: "close-button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                  }, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderItemType) = $event)),
                                class: "form-select",
                                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOrderItemTypeChanged && _ctx.onOrderItemTypeChanged(...args)))
                              }, [
                                _hoisted_13,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemTypes, (orderItemType) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: orderItemType.name,
                                    value: orderItemType.value
                                  }, _toDisplayString(orderItemType.name), 9, _hoisted_14))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.orderItemType]
                              ])
                            ])
                          ]),
                          (_ctx.orderItemType === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("div", _hoisted_17, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.substrateId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubstrateChanged && _ctx.onSubstrateChanged(...args)))
                                  }, [
                                    _hoisted_18,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.substrates, (substrate) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: substrate.Id,
                                        value: substrate.Id
                                      }, _toDisplayString(substrate.Name), 9, _hoisted_19))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.substrateId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 3 && _ctx.substrateId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("input", {
                                    value: `${this.widthInches} x ${this.heightInches}`,
                                    type: "text",
                                    class: "form-control",
                                    disabled: ""
                                  }, null, 8, _hoisted_23)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 3 && _ctx.substrateId && (_ctx.substrateId < 56 || _ctx.substrateId > 59))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("div", _hoisted_26, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fixingId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFixingChanged && _ctx.onFixingChanged(...args)))
                                  }, [
                                    _hoisted_27,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixings, (fixing) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: fixing.Id,
                                        value: fixing.Id
                                      }, _toDisplayString(fixing.Name), 9, _hoisted_28))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.fixingId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 3 && _ctx.substrate?.SupportsBacking)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("div", _hoisted_31, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.backingId) = $event)),
                                    class: "form-select",
                                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onBackingChanged && _ctx.onBackingChanged(...args)))
                                  }, [
                                    _hoisted_32,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backings, (backing) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: backing.Id,
                                        value: backing.Id
                                      }, _toDisplayString(backing.Name), 9, _hoisted_33))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.backingId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 3 && _ctx.substrateId && _ctx.substrateColours.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.substrateColourId) = $event)),
                                    class: "form-select"
                                  }, [
                                    _hoisted_37,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.substrateColours, (substrateColour) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: substrateColour.Id,
                                        value: substrateColour.Id
                                      }, _toDisplayString(substrateColour.Name), 9, _hoisted_38))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.substrateColourId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 3 && _ctx.substrate?.SupportsLamination)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("div", _hoisted_41, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.laminationId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onLaminationChanged && _ctx.onLaminationChanged(...args)))
                                  }, [
                                    _hoisted_42,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.laminations, (lamination) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: lamination.Id,
                                        value: lamination.Id
                                      }, _toDisplayString(lamination.Name), 9, _hoisted_43))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.laminationId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _hoisted_45,
                                _createElementVNode("div", _hoisted_46, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.frameTypeId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onFrameTypeChange && _ctx.onFrameTypeChange(...args)))
                                  }, [
                                    _hoisted_47,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frameTypes, (frameType) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: frameType.Id,
                                        value: frameType.Id
                                      }, _toDisplayString(frameType.Name), 9, _hoisted_48))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.frameTypeId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2 && _ctx.frameTypeId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.mouldingId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onMouldingChanged && _ctx.onMouldingChanged(...args)))
                                  }, [
                                    _hoisted_52,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouldings, (moulding) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: moulding.EntityId,
                                        value: moulding.EntityId
                                      }, _toDisplayString(moulding.Description), 9, _hoisted_53))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.mouldingId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2 && _ctx.mouldingId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("input", {
                                    value: `${this.widthInches} x ${this.heightInches}`,
                                    type: "text",
                                    class: "form-control",
                                    disabled: ""
                                  }, null, 8, _hoisted_57)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2 && _ctx.mouldingId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                _hoisted_59,
                                _createElementVNode("div", _hoisted_60, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.glassId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onGlassChanged && _ctx.onGlassChanged(...args)))
                                  }, [
                                    _hoisted_61,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.glasses, (glass) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: glass.Id,
                                        value: glass.Id
                                      }, _toDisplayString(glass.Name), 9, _hoisted_62))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.glassId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2 && _ctx.mouldingId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("div", _hoisted_65, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.hangingOptionId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onHangingOptionChanged && _ctx.onHangingOptionChanged(...args)))
                                  }, [
                                    _hoisted_66,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hangingOptions, (hangingOption) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: hangingOption.Id,
                                        value: hangingOption.Id
                                      }, _toDisplayString(hangingOption.Name), 9, _hoisted_67))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.hangingOptionId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2 && _ctx.mouldingId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _hoisted_69,
                                _createElementVNode("div", _hoisted_70, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.windowMountId) = $event)),
                                    class: "form-select",
                                    onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onWindowMountChanged && _ctx.onWindowMountChanged(...args)))
                                  }, [
                                    _hoisted_71,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windowMounts, (windowMount) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: windowMount.Id,
                                        value: windowMount.Id
                                      }, _toDisplayString(windowMount.Name), 9, _hoisted_72))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, _ctx.windowMountId]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderItemType === 2 && _ctx.mouldingId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _hoisted_78,
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.borderTopMm) = $event)),
                                        type: "text",
                                        class: "form-control"
                                      }, null, 512), [
                                        [_vModelText, _ctx.borderTopMm]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                      _hoisted_80,
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.borderRightMm) = $event)),
                                        type: "text",
                                        class: "form-control"
                                      }, null, 512), [
                                        [_vModelText, _ctx.borderRightMm]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                      _hoisted_82,
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.borderBottomMm) = $event)),
                                        type: "text",
                                        class: "form-control"
                                      }, null, 512), [
                                        [_vModelText, _ctx.borderBottomMm]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_83, [
                                      _hoisted_84,
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.borderLeftMm) = $event)),
                                        type: "text",
                                        class: "form-control"
                                      }, null, 512), [
                                        [_vModelText, _ctx.borderLeftMm]
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, " Price Excluding VAT, " + _toDisplayString(_ctx.currencySymbol) + ": ", 1),
                            _createElementVNode("div", _hoisted_87, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.priceExcludingVat) = $event)),
                                type: "text",
                                class: "form-control"
                              }, null, 512), [
                                [_vModelText, _ctx.priceExcludingVat]
                              ])
                            ])
                          ])
                        ]),
                        _hoisted_88,
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createElementVNode("div", _hoisted_91, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.deliveryOptionId) = $event)),
                              class: "form-select",
                              onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.onDeliveryOptionChange && _ctx.onDeliveryOptionChange(...args)))
                            }, [
                              _hoisted_92,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryOptions, (delivery) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: delivery.Id,
                                  value: delivery.Id
                                }, _toDisplayString(delivery.Name), 9, _hoisted_93))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, _ctx.deliveryOptionId]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          (_ctx.deliveryOptionId!=null)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.deliveryPriceJson, (dp, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `dp_${index}`,
                                  class: _normalizeClass(["row mt-1", {'alt-row' : index % 2}])
                                }, [
                                  _createElementVNode("div", _hoisted_95, _toDisplayString(dp.Name), 1),
                                  _createElementVNode("div", _hoisted_96, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dp.Prices, (p, pIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `p_${pIndex}`,
                                        class: "row mt-1"
                                      }, [
                                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.currencies[p.CurrencyId]), 1),
                                        _createElementVNode("div", _hoisted_98, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                                            type: "text",
                                            class: "form-control"
                                          }, null, 8, _hoisted_99), [
                                            [_vModelText, p.Value]
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ], 2))
                              }), 128))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, _hoisted_102))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "btn btn-success mx-1",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.save())),
                        disabled: !_ctx.isValid()
                      }, " Save ", 8, _hoisted_104),
                      _createElementVNode("button", {
                        class: "btn btn-danger",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.close()))
                      }, " Close ")
                    ])
                  ], true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}